import type { ReactNode } from 'react';

import styles from './Form.module.css';

interface ChoiceProps {
  readonly selected: boolean;
  readonly onSelect: () => void;
  readonly children: ReactNode;
}

/** Choix en pilule (budget, délai…). Un bouton à bascule, lu comme tel. */
export function ChoiceChip({ selected, onSelect, children }: ChoiceProps) {
  return (
    <button type="button" className={styles.chip} aria-pressed={selected} onClick={onSelect}>
      {children}
    </button>
  );
}

/** Grande carte de choix avec icône, titre et description. */
export function ChoiceCard({
  selected,
  onSelect,
  icon,
  title,
  description,
}: Omit<ChoiceProps, 'children'> & {
  readonly icon: ReactNode;
  readonly title: string;
  readonly description?: string;
}) {
  return (
    <button type="button" className={styles.card} aria-pressed={selected} onClick={onSelect}>
      <span className={styles.cardIcon} aria-hidden="true">
        {icon}
      </span>
      <span className={styles.cardText}>
        <span className={styles.cardTitle}>{title}</span>
        {description && <span className={styles.cardDescription}>{description}</span>}
      </span>
    </button>
  );
}
